function getCardSizeData(max_grid_width, max_grid_height, col_count, row_count, card_ratio) {

	let max_card_width = Math.floor(max_grid_width / col_count)
	let max_card_height = Math.floor(max_grid_height / row_count)

	if (max_card_width / card_ratio < max_card_height) {
		max_card_height = max_card_width / card_ratio
	} else {
		max_card_width = max_card_height * card_ratio
	}

	const card_size = max_card_width * max_card_height

	return {
		size: card_size,
		width: max_card_width,
		height: max_card_height,
		cols: col_count,
		rows: row_count,
		score: 0,
	}
}

function buildGrid(max_grid_width, max_grid_height, number_of_tiles, card_ratio = 1) {
	let row_count = 1
	let col_count
	const results = []
	while (row_count <= number_of_tiles) {
		col_count = Math.ceil(number_of_tiles / row_count)
		results.push(getCardSizeData(max_grid_width, max_grid_height, col_count, row_count, card_ratio))
		row_count += 1
	}
	col_count = 1
	while (col_count <= number_of_tiles) {
		row_count = Math.ceil(number_of_tiles / col_count)
		results.push(getCardSizeData(max_grid_width, max_grid_height, col_count, row_count, card_ratio))
		col_count += 1
	}

	//sorting list by size incrementally which will allow to score by size decrementally.
	results.sort(function(a, b) {
		return a.size - b.size
	})

	//scoring result by size.
	// and by row/col ratio.
	const TOTAL_RESULTS = results.length
	results.forEach((item, index) => {
		item.score += Math.round( 10 * index / TOTAL_RESULTS)
		item.score += Math.round( 10 * (number_of_tiles - Math.abs(item.cols - item.rows)) / number_of_tiles)
	})

	//doing final sort by score
	results.sort(function(a, b) {
		return b.score - a.score
	})


	return results
}

export function filterGrid(grid, size) {
	return grid.filter(grid_item => grid_item.size > size)
}

export default buildGrid
